import { IonCol, IonRow, IonText } from "@ionic/react";
import SummarySubtotalRow from "./SummarySubtotalRow";

/** Row variant that mirrors the parent subsection card pattern: a dark header with a trailing chip on the right and a small light-gray subtotal underlay below. Used for individual entry rows in the Entries section so each row visually matches the Entries/Stabling/Show Fees subsection cards. */
interface SummaryItemRowWithUnderlayProps {
    label: string;
    trailing?: React.ReactNode;
    underlayAmountUsd: number;
    underlayLabel?: string;
    underlayLoading?: boolean;
    onRowClick?: () => void;
}

const SummaryItemRowWithUnderlay: React.FC<SummaryItemRowWithUnderlayProps> = ({
    label,
    trailing,
    underlayAmountUsd,
    underlayLabel = "Subtotal",
    underlayLoading = false,
    onRowClick,
}) => {
    const rowInteractive = Boolean(onRowClick);
    return (
        <div
            onClick={onRowClick ? () => onRowClick() : undefined}
            onKeyDown={
                onRowClick
                    ? (e) => {
                          if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              onRowClick();
                          }
                      }
                    : undefined
            }
            role={rowInteractive ? "button" : undefined}
            tabIndex={rowInteractive ? 0 : undefined}
            aria-label={rowInteractive ? `Open ${label}` : undefined}
            className={`mb-2 summary-item-row-underlay${rowInteractive ? " summary-item-row-underlay--interactive" : ""}${
                underlayLoading ? " saving-blink-animation" : ""
            }`}
            aria-busy={underlayLoading || undefined}>
            <IonRow className="ion-align-items-center ion-justify-content-between px-2 py-2 mx-0 summary-item-row-underlay__header">
                <IonCol className="ion-no-padding summary-item-row__label-col">
                    <IonText className="font-weight-bold text-white ion-text-wrap summary-item-row__label-text">{label}</IonText>
                </IonCol>
                {trailing ? (
                    <IonCol size="auto" className="ion-no-padding d-flex ion-align-items-center ion-justify-content-end summary-item-row__value-col">
                        {trailing}
                    </IonCol>
                ) : null}
            </IonRow>
            <div className="px-2 py-1 summary-item-row-underlay__body">
                <SummarySubtotalRow
                    amountUsd={underlayAmountUsd}
                    label={underlayLabel}
                    showTopBorder={false}
                    removeTopSpacing={true}
                    textTone="dark"
                    isLoading={underlayLoading}
                    animateLoading={false}
                />
            </div>
        </div>
    );
};

export default SummaryItemRowWithUnderlay;
